// Color constants
export const NEON_BLUE = '#00f7ff';
export const BRIGHT_BLUE = '#00d8ff';

// Theme configuration
export const theme = {
  colors: {
    background: '#000000',
    surface: 'rgba(0, 15, 30, 0.8)',
    primary: NEON_BLUE,
    secondary: BRIGHT_BLUE,
    text: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.7)',
    success: '#00ff66',
    warning: '#ffaa00',
    error: '#ff0066'
  },
  fonts: {
    heading: "'VT323', monospace",
    body: "'Roboto', sans-serif"
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem'
  },
  shadows: {
    neon: `0 0 10px ${NEON_BLUE}, 0 0 20px ${NEON_BLUE}, 0 0 30px ${NEON_BLUE}`,
    subtle: `0 0 5px ${NEON_BLUE}`
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    slow: 'all 0.6s ease'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px'
  },
  effects: {
    glowPrimary: '0 0 10px rgba(0,240,255,0.5), 0 0 20px rgba(0,240,255,0.3), 0 0 30px rgba(0,240,255,0.1)',
    glowSecondary: '0 0 10px rgba(255,0,85,0.5), 0 0 20px rgba(255,0,85,0.3), 0 0 30px rgba(255,0,85,0.1)',
    glowAccent1: '0 0 10px rgba(247,0,255,0.5), 0 0 20px rgba(247,0,255,0.3), 0 0 30px rgba(247,0,255,0.1)',
    scanline: 'repeating-linear-gradient(transparent 0px, rgba(0, 240, 255, 0.03) 1px, transparent 2px)',
    noise: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'3\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")',
  },
  animations: {
    flicker: 'flicker 2s linear infinite',
    pulse: 'pulse 3s ease infinite',
    glitch: 'glitch 0.5s ease',
    float: 'float 6s ease-in-out infinite',
  },
} 